import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'
import {TextField} from 'formik-material-ui'

import {DatePickerField} from '../../../../components/DatePickerField'
import SelectField from '../../../../components/SelectField'
import {ID_ISSUING_ENTITIES} from '../../../../constants'
import {StepHeader} from '../../styles'

const Step2 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            component="h5"
            variant="h5"
            gutterBottom
            color="textPrimary">
            Vamos criar sua conta
          </Typography>
          <Typography
            component="p"
            variant="body1"
            gutterBottom
            color="textPrimary">
            Sua vida vai ficar mais simples, sem burocracia nem papelada.
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              type="tel"
              name="id"
              label="Digite o número do seu RG"
              fullWidth
              helperText="Digite apenas números"
              component={TextField}
            />
          </Grid>
          <Grid item xs={7}>
            <Field
              type="tel"
              fullWidth
              name="idIssueDate"
              component={DatePickerField}
              label="Data de emissão"
              helperText="Como consta no seu documento."
            />
          </Grid>
          <Grid item xs={5}>
            <Field
              label="Orgão Emissor"
              native
              name="idIssuingEntity"
              component={SelectField}
            >
              <option aria-label="None" value="" />
              {ID_ISSUING_ENTITIES.map(({label, value}) => (
                <option value={value}>{`${value} - ${label}`}</option>
              ))}
            </Field>
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step2;
